import * as action from '../Action-type/Index';


export function actionName(data) {
  return {
    type: action.ACTION_NAME,
    payload: {
      vari: data
    }
  }
}

export function deleteData() {
  return {
    type: action.DELETE_DATA
  }
}


export function openFile(graphicsAcucumulated, graphicsWorkSpace) {
  return {
    type: action.OPEN_FILE,
    payload: {
      graphicsAcucumulated,
      graphicsWorkSpace
    }
  }
}

export function noHeader() {
  return {
    type: action.NO_HEADER,
  }
}

export function accumulateShields(graphic, type, width, height) {
  return {
    type: action.SELECT_SHIELD,
    payload: {
      graphic,
      type,
      width,
      height
    }
  }
}
export function accumulateTexts() {
  return {
    type: action.MORE_TEXT
  }
}

export function editClassText(id, classes) {
  return {
    type: action.CHANGE_CLASS_TEXTS,
    payload: {
      id,
      classes
    }
  }
}
export function editText(id, text) {
  return {
    type: action.EDIT_TEXT,
    payload: {
      id,
      text
    }
  }
}
export function activePage(data) {
  return {
    type: action.ACTIVE_PAGE,
    payload: {
      activePage: data
    }
  }
}

export function actionAsyncName(data) {
  return (dispatch) => {
    setTimeout(() => {
      dispatch(actionName(data))
    }, 5000);
  }
}

export function accumulateGraphics(graphic, type, width, height) {
  return {
    type: action.MORE_GRAPHICS,
    payload: {
      graphic,
      type,
      width,
      height
    }
  }
}

export function deaccumulateGraphics(id) {
  return {
    type: action.LESS_GRAPHICS,
    payload: {
      id
    }
  }
}

export function selectGraphics(id) {
  return {
    type: action.ACCOMULATE_INFORM,
    payload: {
      id
    }
  }
}

export function resizeElement(id, width, height) {
  return {
    type: action.RESIZE_ELEMENT,
    payload: {
      id,
      width,
      height
    }
  }
}

export function moveElement(id, x, y) {
  return {
    type: action.MOVE_ELEMENT,
    payload: {
      id,
      x,
      y
    }
  }
}

export function backGraphics(id) {
  return {
    type: action.BACK_GRAPHIC,
    payload: {
      id
    }
  }
}

export function createCopy(id) {
  return {
    type: action.CREATE_COPY,
    payload: {
      id
    }
  }
}

export function deleteInformElement(id) {
  return {
    type: action.DELETE,
    payload: {
      id
    }
  }
}

export function selectFilter(data, type) {
  return {
    type: action.SELECT_FILTER_CHARACTERISTIC,
    payload: {
      ...data,
      name: type
    }
  }
}

export function selectFilterFenomene(data, type) {
  return {
    type: action.SELECT_FILTER_FENOMENE,
    payload: {
      ...data,
      name: type
    }
  }
}

export function signalUpdate() {
  return {
    type: action.SIGNAL_UPDATE,
  }
}

export function signalPoint(group) {
  return {
    type: action.SIGNAL_POINT,
    payload: group
  }
}

export function addedPoint(status, point) {
  return {
    type: action.ADDED_POINT,
    payload: {
      status,
      addedPoint: point
    }
  }
}

export function pointsToShow(points) {
  return {
    type: action.POINTS_TO_SHOW,
    payload: { points }
  }
}

